import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {AuthComponent} from "./Global/AuthContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <AuthComponent>
            <App />
      </AuthComponent>
  </React.StrictMode>
);

